export const environment = {
  production: true,
  environment:"PRD",
  primeraetapa:{
    url:"https://apimaz.grupokaufmann.com/prd/v1/tu-pago/aplicacion/medios/",
    apikey:"cb91790479a24c8a950011ef03d7a107"
  },
  auth:{
    url:"https://apimaz.grupokaufmann.com/prd/v1/tu-pago/auth/login",
    apikey:"cb91790479a24c8a950011ef03d7a107"
  },
  pagarWebpay:{
    url:"https://apimaz.grupokaufmann.com/prd/v1/tu-pago/webpay/iniciar/",
    apikey:"cb91790479a24c8a950011ef03d7a107"
  },
  pagarKhipu:{
    url:"https://apimaz.grupokaufmann.com/prd/v1/tu-pago/khipu/iniciar/",
    apikey:"cb91790479a24c8a950011ef03d7a107"
  },
  pagarMercado:{
    url:"https://apimaz.grupokaufmann.com/prd/v1/tu-pago/mercado-pago/iniciar/",
    apikey:"cb91790479a24c8a950011ef03d7a107"
  },
  pagarForpay:{
    url:"https://apimaz.grupokaufmann.com/prd/v1/tu-pago/forpay/iniciar/",
    apikey:"cb91790479a24c8a950011ef03d7a107"
  },
  retornar:"https://tupago.kaufmann.cl:8443/PasarelaDePago/rest/servicios/retornar",
  finalizarpago:{
    url:"https://apimaz.grupokaufmann.com/prd/v1/tu-pago/webpay/terminar/",
    apikey:"cb91790479a24c8a950011ef03d7a107"
  },
  login:{
    user:"pasarela",
    llave:"zN6MvTYfJ5"
  },
  datadog: {
    clientToken: 'pub9bf520e9fdf9d692e56af49975f56039',
    applicationId: 'c3978b4e-8139-4f8d-bcfc-60402a0c929c',
    site: 'datadoghq.com',
    service: 'pasarela-de-pago',
    env: 'prd',
    enableDatadogLogging: true,
    version: '1.13.0',
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      (url: string) => url.startsWith('https://apimaz.grupokaufmann.com') || url.startsWith('https://tupago.kaufmann.cl')
  ],
  }
};
